import React, {Dispatch, SetStateAction} from 'react';
import ToAnMondialTransferForm
    from "../../../../../components/ToAnMondialTransferForm/ToAnMondialTransferForm";


type PropsType = {
    setCurrent: Dispatch<SetStateAction<number>>
    setTransferData: Dispatch<SetStateAction<any>>
}

const ToAnMondialStepOne = (props: PropsType) => {

    return (
        <ToAnMondialTransferForm
            setCurrent={props.setCurrent}
            setTransferData={props.setTransferData}
        />
    );
};

export default ToAnMondialStepOne;
